import React from "react";

export const SessionCloseIcon = (props: React.SVGAttributes<SVGElement>) => {
  return (
    <svg
      width="577"
      height="438"
      viewBox="0 0 577 438"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M575.555 245.24C578.532 205.637 569.314 164.252 556.976 127.324C538.642 72.6089 503.037 16.3979 443.087 3.45597C408.576 -4.02158 373.345 3.98803 343.708 22.7107C315.207 40.7287 292.976 63.9954 257.946 68.5107C222.5 73.0691 186.133 71.2285 150.5 71.2285C58.8996 71.2285 -15.4445 167.473 3.13431 267.715C21.7131 367.958 109.344 437.398 183.688 437.398C250.483 437.398 305.443 397.322 368.902 386.551C400.365 381.216 431.957 387.529 463.104 379.534C499.284 370.244 533.321 348.07 553.367 315.96C567.042 294.16 573.686 270.045 575.555 245.24Z"
        fill="#57AAEC"
      />
      <path
        opacity="0.7"
        d="M575.555 245.24C578.532 205.637 569.314 164.252 556.976 127.324C538.642 72.6089 503.037 16.3979 443.087 3.45597C408.576 -4.02158 373.345 3.98803 343.708 22.7107C315.207 40.7287 292.976 63.9954 257.946 68.5107C222.5 73.0691 186.133 71.2285 150.5 71.2285C58.8996 71.2285 -15.4445 167.473 3.13431 267.715C21.7131 367.958 109.344 437.398 183.688 437.398C250.483 437.398 305.443 397.322 368.902 386.551C400.365 381.216 431.957 387.529 463.104 379.534C499.284 370.244 533.321 348.07 553.367 315.96C567.042 294.16 573.686 270.045 575.555 245.24Z"
        fill="white"
      />
      <path
        d="M211.844 68.1652V427.663"
        stroke="#263238"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M175.664 106.517H63.9325V202.387H175.664V106.517Z"
        fill="#263238"
        stroke="#263238"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M170.085 111.305H69.5263V197.584H170.085V111.305Z"
        fill="white"
        stroke="#263238"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M170.085 137.462C152.009 150.332 126.097 158.859 96.0429 172.276C86.5779 176.42 77.6697 181.734 69.5263 188.094V197.584H170.085V137.462Z"
        fill="#57AAEC"
        stroke="#263238"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M170.085 111.305H129.735C125.248 115.144 119.928 119.444 113.658 124.046C90.6504 140.884 100.716 157.723 128.211 145.486C142.346 139.188 158.107 124.649 170.085 111.966V111.305Z"
        fill="#57AAEC"
        stroke="#263238"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M86.8541 120.983C86.8541 113.951 78.1112 119.458 69.5983 126.548V144.379C77.9242 136.11 86.8541 127.267 86.8541 120.983Z"
        fill="#57AAEC"
        stroke="#263238"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M152.399 177.1C153.798 171.352 150.272 165.557 144.523 164.158C138.774 162.758 132.98 166.284 131.58 172.033C130.181 177.782 133.707 183.577 139.456 184.976C145.205 186.375 150.999 182.849 152.399 177.1Z"
        fill="white"
        stroke="#263238"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M95.2807 148.923C95.2807 150.513 94.8092 152.067 93.9259 153.389C93.0427 154.711 91.7873 155.741 90.3184 156.349C88.8496 156.958 87.2334 157.117 85.6741 156.807C84.1148 156.497 82.6825 155.731 81.5583 154.607C80.4341 153.483 79.6685 152.05 79.3584 150.491C79.0482 148.932 79.2074 147.316 79.8158 145.847C80.4242 144.378 81.4545 143.123 82.7764 142.239C84.0983 141.356 85.6524 140.885 87.2423 140.885C89.3742 140.885 91.4188 141.731 92.9263 143.239C94.4338 144.746 95.2807 146.791 95.2807 148.923Z"
        fill="#57AAEC"
        stroke="#263238"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M85.7755 264.695V423.823H178.281V264.695H85.7755ZM94.7486 292.664V278.917H99.6953V292.664H94.7486ZM103.175 292.664V278.917H108.28V292.664H103.175ZM111.803 292.664V278.917H116.117V292.664H111.803ZM119.568 292.664V278.917H123.882V292.664H119.568ZM127.333 292.664V278.917H131.647V292.664H127.333ZM135.113 292.664V278.917H139.427V292.664H135.113ZM142.878 292.664V278.917H147.192V292.664H142.878ZM150.658 292.664V278.917H154.972V292.664H150.658ZM158.423 292.664V278.917H162.737V292.664H158.423ZM169.352 292.664H166.188V278.917H169.352V292.664Z"
        fill="white"
        stroke="#263238"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M90.8948 256.902H85.7755V423.824H90.8948V256.902Z"
        fill="white"
        stroke="#263238"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M178.281 256.902H173.162V423.823H178.281V256.902Z"
        fill="white"
        stroke="#263238"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M147.307 298.517C147.307 298.517 142.073 297.079 130.511 301.537C118.95 305.995 112.91 320.518 112.076 322.172C111.242 323.826 106.856 327.924 108.222 329.88C109.589 331.835 113.184 331.318 113.184 331.318H185.816C185.816 331.318 175.923 296.59 147.307 298.517Z"
        fill="white"
        stroke="#263238"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M184.436 294.347C184.436 294.347 190.821 297.223 194.301 298.992C197.78 300.76 200.053 301.609 198.37 296.662C196.688 291.715 190.835 283.619 193.452 281.002C196.069 278.385 248.268 287.085 248.268 287.085V332.669H168.747L170.789 302.472C170.789 302.472 175.722 304.499 178.914 301.307C180.986 299.18 182.836 296.848 184.436 294.347Z"
        fill="white"
        stroke="#263238"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M201.261 309.748L207.962 316.434L192.057 323.135L212.146 331.231H221.076V284.08L192.618 284.64L196.242 296.633L201.261 309.748Z"
        fill="#57AAEC"
        stroke="#263238"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M152.513 312.624C152.513 312.624 153.404 325.393 154.296 329.463C155.187 333.532 158.754 333.777 164.692 332.943C170.631 332.108 200.038 329.463 203 328.298C205.963 327.133 172.112 314.651 167.957 313.487C163.801 312.322 151.923 307.993 152.513 312.624Z"
        fill="#57AAEC"
        stroke="#263238"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M151.621 302.759C151.621 302.759 151.909 306.829 150.758 307.073C149.608 307.318 148.429 300.113 148.429 300.113C148.429 300.113 146.401 308.238 141.757 307.95C137.112 307.663 137.443 290.824 144.633 282.066C151.822 273.309 159.429 270.447 164.664 272.777C169.898 275.107 172.788 281.189 172.788 281.189C174.056 283.515 175.124 285.945 175.981 288.451C176.268 290.191 171.667 289.328 166.979 290.191C162.291 291.054 161.471 289.616 158.854 293.383C156.237 297.151 151.621 302.759 151.621 302.759Z"
        fill="#263238"
        stroke="#263238"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M151.621 302.759C156.78 307.826 163.191 311.434 170.2 313.213C181.819 316.089 190.878 310.136 189.944 304.499C188.204 294.059 178.914 286.51 178.914 286.51C178.902 285.346 178.639 284.199 178.142 283.147C177.646 282.095 176.928 281.162 176.038 280.413C173.162 278.385 170.286 278.385 169.941 280.7C169.79 281.759 169.694 282.824 169.654 283.893L173.723 286.222L172.558 287.085C170.748 286.63 168.899 286.341 167.036 286.222C165.009 286.222 165.296 288.25 162.981 288.25C160.666 288.25 159.199 283.03 158.337 285.633C157.474 288.235 151.621 302.759 151.621 302.759Z"
        fill="white"
        stroke="#263238"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M156.237 306.872C156.237 306.872 159.717 295.253 163.211 289.745C166.706 284.238 173.953 289.745 174.241 293.513C174.528 297.28 170.459 298.747 168.489 301.35C166.519 303.953 168.776 308.324 167.913 310.352C167.051 312.379 160.048 315.83 156.237 306.872Z"
        fill="#263238"
      />
      <path
        d="M166.72 303.636L170.79 307.706L172.53 305.951"
        stroke="#263238"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M215.195 317.858C215.195 317.858 198.643 316.118 186.435 314.378C174.226 312.638 161.989 307.404 156.237 306.829C150.485 306.253 151.017 309.446 149.852 313.213C148.688 316.981 150.428 320.403 151.592 320.403C152.757 320.403 152.182 321.568 152.757 320.403C153.332 319.238 153.634 312.566 153.634 312.566C155.988 313.464 158.388 314.237 160.824 314.881C162.821 315.418 164.924 315.418 166.921 314.881C166.921 314.881 203.216 333.762 210.176 334.337C217.136 334.913 217.15 329.117 216.561 325.623C215.971 322.129 215.195 317.858 215.195 317.858Z"
        fill="white"
        stroke="#263238"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M182.567 310.841L177.634 324.66L200.657 333.216H216.129V315.773L182.567 310.841Z"
        fill="#57AAEC"
        stroke="#263238"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M218.545 274.273C218.545 274.273 188.836 276.199 190.749 282.9C192.661 289.602 216.633 301.594 221.91 301.594C227.188 301.594 218.545 274.273 218.545 274.273Z"
        fill="#57AAEC"
        stroke="#263238"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M171.408 317.829C169.433 317.956 167.53 318.622 165.907 319.755C164.284 320.889 163.004 322.446 162.205 324.257"
        stroke="#263238"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M189.268 294.678L196.515 310.582L206.567 312.25L196.515 295.512L189.268 294.678Z"
        fill="#57AAEC"
        stroke="#263238"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M238.203 270.922C238.203 270.922 280.868 278.586 290.445 278.586C300.022 278.586 312.504 274.273 348.453 279.075C384.403 283.878 403.097 305.908 407.885 308.31C412.674 310.711 438.083 310.222 453.427 314.062C468.77 317.901 482.661 336.106 482.661 336.106H233.889L238.203 270.922Z"
        fill="#57AAEC"
        stroke="#263238"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M291.883 305.434C291.883 305.434 307.7 330.354 324.956 334.194"
        stroke="#263238"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M286.131 308.31C286.131 308.31 296.197 318.85 304.35 324.128"
        stroke="#263238"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M225.979 267.6C225.979 267.6 212.074 269.038 212.074 272.878C212.074 276.717 206.322 285.748 210.262 334.409C210.42 336.394 240.316 336.926 240.216 334.409C237.742 274.459 247.075 271.914 245.148 269.527C243.221 267.14 225.979 267.6 225.979 267.6Z"
        fill="white"
        stroke="#263238"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M537.779 425.262L95.1225 423.824V337.544C95.1225 335.828 95.8042 334.182 97.0178 332.968C98.2313 331.755 99.8772 331.073 101.593 331.073H525.801C527.517 331.073 529.163 331.755 530.376 332.968C531.59 334.182 532.272 335.828 532.272 337.544L537.779 425.262Z"
        fill="white"
      />
      <mask
        id="mask0_10040_28124"
        mask-type="luminance"
        maskUnits="userSpaceOnUse"
        x="95"
        y="331"
        width="443"
        height="95"
      >
        <path
          d="M537.779 425.262L95.1225 423.824V337.544C95.1225 335.828 95.8042 334.182 97.0178 332.968C98.2313 331.755 99.8772 331.073 101.593 331.073H525.801C527.517 331.073 529.163 331.755 530.376 332.968C531.59 334.182 532.272 335.828 532.272 337.544L537.779 425.262Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_10040_28124)">
        <path
          opacity="0.36"
          d="M537.779 425.262L95.1225 423.824V337.544C95.1225 335.828 95.8042 334.182 97.0178 332.968C98.2313 331.755 99.8772 331.073 101.593 331.073H525.801C527.517 331.073 529.163 331.755 530.376 332.968C531.59 334.182 532.272 335.828 532.272 337.544L537.779 425.262Z"
          fill="black"
          stroke="#263238"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <path
        d="M537.779 425.262L95.1225 423.824V337.544C95.1225 335.828 95.8042 334.182 97.0178 332.968C98.2313 331.755 99.8772 331.073 101.593 331.073H525.801C527.517 331.073 529.163 331.755 530.376 332.968C531.59 334.182 532.272 335.828 532.272 337.544L537.779 425.262Z"
        stroke="#263238"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M525.801 331.073H191.971V424.14L537.779 425.262L532.271 337.544C532.271 335.828 531.59 334.182 530.376 332.968C529.163 331.755 527.517 331.073 525.801 331.073Z"
        fill="#57AAEC"
        stroke="#263238"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M530.877 344.605L544.509 423.694C544.523 423.891 544.496 424.089 544.43 424.275C544.364 424.462 544.26 424.632 544.125 424.777C543.99 424.921 543.827 425.036 543.645 425.115C543.464 425.193 543.268 425.233 543.071 425.233H531.653L530.877 344.605Z"
        fill="#263238"
        stroke="#263238"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M525.801 331.073H403.456C401.835 331.073 400.281 331.717 399.135 332.863C397.989 334.009 397.345 335.564 397.345 337.185L391.104 423.824L537.779 425.262L532.271 337.544C532.271 336.694 532.104 335.853 531.779 335.068C531.454 334.283 530.977 333.569 530.376 332.968C529.775 332.368 529.062 331.891 528.277 331.566C527.492 331.241 526.65 331.073 525.801 331.073Z"
        fill="#57AAEC"
        stroke="#263238"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M299.288 424.269L305.817 339.37L294.802 423.867L299.288 424.269Z"
        fill="#263238"
      />
      <path
        d="M522.652 424.269L529.18 339.37L518.165 423.867L522.652 424.269Z"
        fill="#263238"
      />
      <path
        d="M317.048 424.269L312.547 339.37L312.518 423.867L317.048 424.269Z"
        fill="#263238"
      />
      <path
        d="M414.112 424.269L409.611 339.37L409.582 423.867L414.112 424.269Z"
        fill="#263238"
      />
      <path
        d="M226.828 424.269L233.356 339.37L222.327 423.867L226.828 424.269Z"
        fill="#263238"
      />
      <path
        d="M244.587 424.269L240.072 339.37L240.043 423.867L244.587 424.269Z"
        fill="#263238"
      />
      <path
        d="M184.824 330.469C182.523 330.469 178.626 332.238 178.195 334.496C175.923 346.704 178.526 375.234 178.526 388.593C178.357 400.375 177.517 412.137 176.009 423.823H211.283C211.283 423.823 210.392 369.396 209.443 351.924C208.565 335.775 216.503 331.087 216.503 331.087L184.824 330.469Z"
        fill="white"
        stroke="#263238"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M109.79 314.062L99.5945 294.16V266.363H89.8305V294.203L79.6352 314.062C79.3578 314.596 79.223 315.192 79.244 315.794C79.2649 316.395 79.4409 316.981 79.7548 317.495C80.0686 318.008 80.5098 318.432 81.0356 318.725C81.5613 319.018 82.1538 319.17 82.7556 319.167H106.669C107.27 319.166 107.86 319.011 108.383 318.717C108.907 318.423 109.346 318 109.659 317.488C109.972 316.976 110.148 316.392 110.171 315.792C110.194 315.192 110.063 314.596 109.79 314.062Z"
        fill="#57AAEC"
        stroke="#263238"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M120.23 272.115H69.1811L81.9504 228.257H107.475L120.23 272.115Z"
        fill="#263238"
        stroke="#263238"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M138.018 318.376H64.2056V423.823H138.018V318.376Z"
        fill="#263238"
        stroke="#263238"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M138.018 318.376H103.031V423.823H138.018V318.376Z"
        fill="white"
        stroke="#263238"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M136.105 325.566H104.944V348.099H136.105V325.566Z"
        fill="white"
        stroke="#263238"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M128.441 334.668H112.623V338.982H128.441V334.668Z"
        fill="#263238"
        stroke="#263238"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M136.105 356.482H104.944V379.016H136.105V356.482Z"
        fill="white"
        stroke="#263238"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M128.441 365.585H112.623V369.899H128.441V365.585Z"
        fill="#263238"
        stroke="#263238"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M136.105 387.399H104.944V409.932H136.105V387.399Z"
        fill="white"
        stroke="#263238"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M128.441 396.502H112.623V400.816H128.441V396.502Z"
        fill="#263238"
        stroke="#263238"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M223.132 70.2215V239.645C223.132 245.006 227.478 249.352 232.839 249.352L553.755 249.352C559.116 249.352 563.461 245.006 563.461 239.645V70.2215C563.461 64.8607 559.116 60.515 553.755 60.515L232.839 60.515C227.478 60.515 223.132 64.8607 223.132 70.2215Z"
        fill="#263238"
        stroke="#263238"
        strokeMiterlimit="10"
      />
      <path
        d="M549.384 71.6307H235.83V234.914H549.384V71.6307Z"
        fill="white"
        stroke="#263238"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M554.33 149.67C553.587 149.67 552.861 149.891 552.244 150.304C551.626 150.717 551.145 151.304 550.861 151.991C550.578 152.677 550.504 153.433 550.65 154.161C550.796 154.89 551.155 155.558 551.681 156.083C552.208 156.607 552.878 156.963 553.607 157.106C554.336 157.25 555.091 157.173 555.776 156.887C556.462 156.601 557.047 156.117 557.458 155.498C557.868 154.879 558.086 154.152 558.083 153.409C558.083 152.917 557.986 152.43 557.797 151.975C557.609 151.521 557.332 151.108 556.983 150.76C556.634 150.413 556.221 150.138 555.765 149.951C555.31 149.764 554.822 149.669 554.33 149.67Z"
        fill="white"
      />
      <path
        d="M307.226 88.9585L315.638 214.596C315.661 214.745 315.737 214.882 315.851 214.98C315.966 215.079 316.112 215.133 316.264 215.133C316.415 215.133 316.561 215.079 316.676 214.98C316.791 214.882 316.867 214.745 316.889 214.596L325.431 133.493C325.454 133.343 325.529 133.207 325.644 133.108C325.759 133.01 325.905 132.955 326.057 132.955C326.208 132.955 326.354 133.01 326.469 133.108C326.584 133.207 326.659 133.343 326.682 133.493L333.397 215.458C333.397 215.626 333.464 215.787 333.583 215.906C333.701 216.025 333.862 216.091 334.03 216.091C334.198 216.091 334.359 216.025 334.478 215.906C334.596 215.787 334.663 215.626 334.663 215.458L348.094 96.9681C348.094 96.8003 348.16 96.6393 348.279 96.5207C348.398 96.402 348.559 96.3353 348.726 96.3353C348.894 96.3353 349.055 96.402 349.174 96.5207C349.292 96.6393 349.359 96.8003 349.359 96.9681L355.672 213.402C355.672 213.57 355.739 213.731 355.857 213.85C355.976 213.968 356.137 214.035 356.305 214.035C356.472 214.035 356.633 213.968 356.752 213.85C356.871 213.731 356.937 213.57 356.937 213.402L364.386 134.313C364.386 134.145 364.453 133.984 364.571 133.865C364.69 133.747 364.851 133.68 365.019 133.68C365.187 133.68 365.348 133.747 365.466 133.865C365.585 133.984 365.652 134.145 365.652 134.313L372.741 214.668C372.741 214.835 372.808 214.996 372.926 215.115C373.045 215.234 373.206 215.3 373.374 215.3C373.541 215.3 373.702 215.234 373.821 215.115C373.94 214.996 374.006 214.835 374.006 214.668L383.799 98.1185C383.822 97.9689 383.897 97.8324 384.012 97.7337C384.127 97.6351 384.273 97.5809 384.425 97.5809C384.576 97.5809 384.722 97.6351 384.837 97.7337C384.952 97.8324 385.027 97.9689 385.05 98.1185L392.556 216.034C392.566 216.186 392.632 216.33 392.74 216.439C392.848 216.547 392.991 216.613 393.144 216.623C393.297 216.634 393.448 216.589 393.57 216.496C393.692 216.404 393.777 216.27 393.807 216.12L406.131 155.48C406.162 155.339 406.24 155.212 406.352 155.121C406.465 155.031 406.605 154.981 406.749 154.981C406.894 154.981 407.034 155.031 407.146 155.121C407.259 155.212 407.337 155.339 407.368 155.48L419.26 216.911C419.283 217.06 419.358 217.197 419.473 217.296C419.588 217.394 419.734 217.448 419.885 217.448C420.037 217.448 420.183 217.394 420.298 217.296C420.413 217.197 420.488 217.06 420.511 216.911L429.455 115C429.478 114.851 429.554 114.714 429.668 114.616C429.783 114.517 429.929 114.463 430.081 114.463C430.232 114.463 430.378 114.517 430.493 114.616C430.608 114.714 430.684 114.851 430.706 115L439.564 214.926C439.564 215.094 439.631 215.255 439.75 215.374C439.868 215.492 440.029 215.559 440.197 215.559C440.365 215.559 440.526 215.492 440.644 215.374C440.763 215.255 440.83 215.094 440.83 214.926L451.025 133.608C451.048 133.458 451.123 133.322 451.238 133.223C451.353 133.125 451.499 133.07 451.651 133.07C451.802 133.07 451.948 133.125 452.063 133.223C452.178 133.322 452.253 133.458 452.276 133.608L458.474 215.128C458.474 215.296 458.541 215.456 458.659 215.575C458.778 215.694 458.939 215.76 459.107 215.76C459.274 215.76 459.435 215.694 459.554 215.575C459.673 215.456 459.739 215.296 459.739 215.128L471.157 96.9249C471.157 96.7571 471.224 96.5962 471.342 96.4775C471.461 96.3589 471.622 96.2922 471.79 96.2922C471.957 96.2922 472.118 96.3589 472.237 96.4775C472.356 96.5962 472.422 96.7571 472.422 96.9249L479.684 212.683C479.684 212.851 479.751 213.012 479.87 213.131C479.988 213.249 480.149 213.316 480.317 213.316C480.485 213.316 480.646 213.249 480.764 213.131C480.883 213.012 480.95 212.851 480.95 212.683L487.449 124.52C487.472 124.37 487.548 124.234 487.663 124.135C487.777 124.037 487.924 123.982 488.075 123.982C488.226 123.982 488.373 124.037 488.487 124.135C488.602 124.234 488.678 124.37 488.7 124.52L495.775 214.466C495.798 214.616 495.874 214.752 495.988 214.851C496.103 214.95 496.25 215.004 496.401 215.004C496.552 215.004 496.699 214.95 496.813 214.851C496.928 214.752 497.004 214.616 497.026 214.466L504.015 125.469C504.015 125.301 504.082 125.14 504.2 125.022C504.319 124.903 504.48 124.836 504.648 124.836C504.816 124.836 504.977 124.903 505.095 125.022C505.214 125.14 505.28 125.301 505.28 125.469L510.4 213.934C510.4 214.102 510.466 214.263 510.585 214.382C510.704 214.5 510.865 214.567 511.032 214.567C511.2 214.567 511.361 214.5 511.48 214.382C511.598 214.263 511.665 214.102 511.665 213.934L524.219 88.9153"
        stroke="#57AAEC"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M297.16 89.5194H298.598"
        stroke="#263238"
        strokeWidth="0.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M301.46 89.5194H529.079"
        stroke="#263238"
        strokeWidth="0.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        stroke-dasharray="1.99 1.99"
      />
      <path
        d="M530.517 89.5194H531.955"
        stroke="#263238"
        strokeWidth="0.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M297.16 126.792H298.598"
        stroke="#263238"
        strokeWidth="0.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M301.46 126.792H529.079"
        stroke="#263238"
        strokeWidth="0.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        stroke-dasharray="1.99 1.99"
      />
      <path
        d="M530.517 126.792H531.955"
        stroke="#263238"
        strokeWidth="0.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M297.16 221.929H298.598"
        stroke="#263238"
        strokeWidth="0.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M301.46 221.929H529.079"
        stroke="#263238"
        strokeWidth="0.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        stroke-dasharray="1.99 1.99"
      />
      <path
        d="M530.517 221.929H531.955"
        stroke="#263238"
        strokeWidth="0.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M307.959 219.701V224.906"
        stroke="#263238"
        strokeWidth="0.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M321.218 219.701V224.906"
        stroke="#263238"
        strokeWidth="0.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M334.49 219.701V224.906"
        stroke="#263238"
        strokeWidth="0.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M347.749 219.701V224.906"
        stroke="#263238"
        strokeWidth="0.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M361.021 219.701V224.906"
        stroke="#263238"
        strokeWidth="0.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M374.28 219.701V224.906"
        stroke="#263238"
        strokeWidth="0.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M387.552 219.701V224.906"
        stroke="#263238"
        strokeWidth="0.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M400.81 219.701V224.906"
        stroke="#263238"
        strokeWidth="0.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M414.069 219.701V224.906"
        stroke="#263238"
        strokeWidth="0.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M427.341 219.701V224.906"
        stroke="#263238"
        strokeWidth="0.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M440.6 219.701V224.906"
        stroke="#263238"
        strokeWidth="0.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M453.872 219.701V224.906"
        stroke="#263238"
        strokeWidth="0.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M467.131 219.701V224.906"
        stroke="#263238"
        strokeWidth="0.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M480.403 219.701V224.906"
        stroke="#263238"
        strokeWidth="0.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M493.662 219.701V224.906"
        stroke="#263238"
        strokeWidth="0.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M506.934 219.701V224.906"
        stroke="#263238"
        strokeWidth="0.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M520.192 219.701V224.906"
        stroke="#263238"
        strokeWidth="0.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M252.928 89.8644H250.052L249.419 91.3024H249.031L251.303 86.3701H251.662L253.934 91.3024H253.546L252.928 89.8644ZM252.798 89.5624L251.504 86.6864L250.21 89.5624H252.798Z"
        fill="#263238"
      />
      <path
        d="M259.772 87.5781L258.334 91.2593H258.004L256.767 88.067L255.516 91.2593H255.2L253.762 87.5781H254.092L255.329 90.8567L256.58 87.5781H256.882L258.133 90.8567L259.37 87.5781H259.772Z"
        fill="#263238"
      />
      <path
        d="M263.166 88.9296V91.2592H262.821V90.5977C262.685 90.8228 262.489 91.0061 262.256 91.1278C262.023 91.2495 261.761 91.3049 261.498 91.2879C260.678 91.2879 260.175 90.8565 260.175 90.2382C260.175 89.6199 260.52 89.2029 261.541 89.2029H262.807V88.9152C262.824 88.7694 262.807 88.6215 262.758 88.4832C262.708 88.3448 262.628 88.2199 262.522 88.1181C262.416 88.0163 262.288 87.9406 262.147 87.8967C262.007 87.8529 261.859 87.8422 261.714 87.8655C261.25 87.8604 260.8 88.024 260.448 88.3257L260.276 88.0668C260.68 87.7313 261.189 87.5481 261.714 87.5491C261.905 87.5165 262.102 87.529 262.288 87.5857C262.474 87.6424 262.645 87.7417 262.786 87.8757C262.927 88.0097 263.034 88.1747 263.1 88.3577C263.166 88.5406 263.189 88.7365 263.166 88.9296ZM262.807 90.1663V89.4761H261.555C260.793 89.4761 260.52 89.7924 260.52 90.2238C260.52 90.6552 260.894 91.0003 261.541 91.0003C261.814 91.0165 262.084 90.944 262.312 90.7937C262.541 90.6434 262.714 90.4233 262.807 90.1663Z"
        fill="#263238"
      />
      <path
        d="M265.913 89.2893L264.963 90.1665V91.2593H264.604V86.0251H264.963V89.7351L267.307 87.5925H267.768L266.186 89.0304L267.926 91.2306H267.48L265.913 89.2893Z"
        fill="#263238"
      />
      <path
        d="M271.708 89.505H268.544C268.563 89.8135 268.673 90.1096 268.86 90.3559C269.047 90.6022 269.302 90.7877 269.594 90.8891C269.886 90.9906 270.202 91.0034 270.501 90.926C270.8 90.8486 271.07 90.6844 271.276 90.454L271.478 90.6841C271.302 90.8906 271.081 91.0529 270.831 91.1578C270.581 91.2628 270.31 91.3074 270.04 91.2881C269.789 91.3024 269.538 91.264 269.303 91.1755C269.069 91.087 268.855 90.9503 268.676 90.7742C268.497 90.5981 268.357 90.3865 268.265 90.153C268.173 89.9196 268.131 89.6694 268.141 89.4187C268.141 89.1883 268.187 88.9602 268.275 88.7473C268.363 88.5345 268.492 88.3411 268.655 88.1782C268.818 88.0153 269.012 87.886 269.224 87.7979C269.437 87.7097 269.665 87.6643 269.896 87.6643C270.126 87.6643 270.354 87.7097 270.567 87.7979C270.78 87.886 270.973 88.0153 271.136 88.1782C271.299 88.3411 271.428 88.5345 271.517 88.7473C271.605 88.9602 271.65 89.1883 271.65 89.4187L271.708 89.505ZM268.544 89.2317H271.42C271.42 88.8504 271.269 88.4846 270.999 88.2149C270.729 87.9453 270.363 87.7938 269.982 87.7938C269.601 87.7938 269.235 87.9453 268.965 88.2149C268.696 88.4846 268.544 88.8504 268.544 89.2317Z"
        fill="#263238"
      />
      <path
        d="M249.879 123.312H250.238V127.928H253.114V128.244H249.908L249.879 123.312Z"
        fill="#263238"
      />
      <path
        d="M253.776 123.384C253.779 123.309 253.811 123.238 253.864 123.185C253.917 123.131 253.988 123.1 254.063 123.096C254.12 123.096 254.176 123.113 254.223 123.145C254.271 123.176 254.307 123.221 254.329 123.274C254.351 123.326 254.357 123.384 254.346 123.44C254.334 123.496 254.307 123.547 254.267 123.587C254.227 123.628 254.175 123.655 254.12 123.666C254.064 123.677 254.006 123.671 253.953 123.65C253.901 123.628 253.856 123.591 253.824 123.544C253.793 123.496 253.776 123.441 253.776 123.384ZM253.891 124.563H254.236V128.244H253.891V124.563Z"
        fill="#263238"
      />
      <path
        d="M259.039 124.563V127.856C259.075 128.099 259.055 128.347 258.978 128.579C258.901 128.812 258.771 129.024 258.597 129.198C258.424 129.371 258.212 129.501 257.979 129.578C257.746 129.655 257.498 129.676 257.256 129.639C256.64 129.664 256.039 129.454 255.573 129.05L255.76 128.791C256.161 129.134 256.671 129.322 257.198 129.323C258.191 129.323 258.636 128.877 258.636 127.885V127.252C258.484 127.519 258.261 127.74 257.993 127.889C257.724 128.039 257.419 128.112 257.112 128.101C256.863 128.123 256.613 128.093 256.376 128.013C256.14 127.934 255.923 127.805 255.739 127.637C255.554 127.469 255.407 127.264 255.307 127.035C255.206 126.807 255.154 126.56 255.154 126.31C255.154 126.061 255.206 125.814 255.307 125.586C255.407 125.357 255.554 125.152 255.739 124.984C255.923 124.815 256.14 124.687 256.376 124.607C256.613 124.527 256.863 124.498 257.112 124.52C257.423 124.507 257.732 124.581 258.004 124.734C258.275 124.886 258.499 125.111 258.651 125.383V124.549L259.039 124.563ZM258.694 126.318C258.694 126.036 258.611 125.761 258.456 125.527C258.301 125.292 258.08 125.108 257.821 124.997C257.563 124.887 257.278 124.854 257.001 124.904C256.724 124.954 256.468 125.084 256.264 125.278C256.06 125.472 255.918 125.721 255.855 125.996C255.791 126.27 255.81 126.556 255.908 126.82C256.006 127.084 256.179 127.313 256.406 127.479C256.632 127.645 256.903 127.741 257.184 127.756C257.379 127.765 257.574 127.735 257.756 127.667C257.939 127.6 258.106 127.495 258.248 127.361C258.389 127.226 258.501 127.064 258.578 126.885C258.655 126.706 258.694 126.513 258.694 126.318Z"
        fill="#263238"
      />
      <path
        d="M263.813 126.102V128.244H263.468V126.131C263.492 125.964 263.479 125.795 263.428 125.634C263.378 125.474 263.293 125.327 263.178 125.204C263.064 125.081 262.923 124.986 262.767 124.925C262.61 124.863 262.442 124.838 262.274 124.851C262.081 124.833 261.886 124.858 261.704 124.924C261.521 124.99 261.356 125.095 261.218 125.233C261.081 125.37 260.976 125.536 260.91 125.718C260.844 125.901 260.819 126.095 260.836 126.289V128.244H260.477V123.024H260.836V125.34C260.974 125.082 261.182 124.869 261.437 124.726C261.692 124.583 261.983 124.517 262.274 124.534C262.483 124.519 262.692 124.549 262.888 124.623C263.084 124.696 263.261 124.812 263.407 124.961C263.554 125.11 263.666 125.29 263.736 125.487C263.806 125.684 263.832 125.894 263.813 126.102Z"
        fill="#263238"
      />
      <path
        d="M267.092 128.014C266.877 128.188 266.606 128.28 266.33 128.273C266.195 128.287 266.058 128.27 265.931 128.224C265.803 128.178 265.687 128.104 265.592 128.008C265.497 127.911 265.424 127.794 265.38 127.666C265.336 127.538 265.322 127.401 265.337 127.267V124.865H264.662V124.563H265.337V123.758H265.682V124.563H266.862V124.865H265.682V127.238C265.682 127.712 265.913 127.971 266.373 127.971C266.578 127.975 266.778 127.904 266.934 127.77L267.092 128.014Z"
        fill="#263238"
      />
      <path
        d="M269.479 127.612L269.651 127.338C270.091 127.749 270.675 127.971 271.276 127.957C272.254 127.957 272.714 127.54 272.714 126.993C272.714 125.555 269.637 126.404 269.637 124.592C269.637 123.887 270.169 123.283 271.377 123.283C271.888 123.288 272.386 123.437 272.815 123.715L272.671 124.017C272.273 123.744 271.802 123.598 271.319 123.6C270.37 123.6 269.881 124.045 269.881 124.578C269.881 126.016 272.959 125.181 272.959 126.979C272.959 127.669 272.398 128.273 271.176 128.273C270.548 128.268 269.944 128.033 269.479 127.612Z"
        fill="#263238"
      />
      <path
        d="M274.152 123.024H274.497V128.244H274.152V123.024Z"
        fill="#263238"
      />
      <path
        d="M279.099 126.49H275.935C275.935 126.69 275.976 126.889 276.056 127.072C276.136 127.256 276.254 127.42 276.401 127.556C276.549 127.691 276.723 127.794 276.913 127.858C277.102 127.922 277.303 127.946 277.503 127.928C277.724 127.937 277.944 127.895 278.146 127.805C278.348 127.716 278.526 127.581 278.668 127.411L278.883 127.641C278.706 127.845 278.484 128.006 278.235 128.111C277.986 128.216 277.715 128.262 277.445 128.245C277.195 128.257 276.945 128.217 276.712 128.127C276.478 128.038 276.265 127.901 276.087 127.726C275.908 127.55 275.768 127.339 275.675 127.107C275.583 126.875 275.539 126.625 275.547 126.375C275.533 126.135 275.569 125.894 275.652 125.667C275.734 125.441 275.863 125.234 276.028 125.059C276.194 124.884 276.393 124.744 276.615 124.649C276.836 124.554 277.075 124.505 277.316 124.506C277.556 124.503 277.793 124.55 278.014 124.644C278.235 124.738 278.433 124.876 278.598 125.05C278.763 125.224 278.89 125.431 278.971 125.656C279.052 125.882 279.086 126.122 279.07 126.361C279.07 126.361 279.099 126.461 279.099 126.49ZM275.95 126.217H278.826C278.826 125.836 278.674 125.47 278.405 125.2C278.135 124.93 277.769 124.779 277.388 124.779C277.006 124.779 276.641 124.93 276.371 125.2C276.101 125.47 275.95 125.836 275.95 126.217Z"
        fill="#263238"
      />
      <path
        d="M283.312 126.49H280.149C280.148 126.689 280.189 126.886 280.268 127.068C280.347 127.251 280.464 127.415 280.61 127.55C280.756 127.685 280.928 127.788 281.116 127.853C281.304 127.918 281.503 127.944 281.702 127.928C281.925 127.939 282.148 127.898 282.352 127.809C282.557 127.719 282.738 127.582 282.881 127.41L283.082 127.64C282.905 127.845 282.683 128.006 282.434 128.111C282.185 128.216 281.914 128.261 281.644 128.244C281.395 128.257 281.146 128.217 280.913 128.127C280.679 128.038 280.467 127.901 280.29 127.725C280.113 127.549 279.974 127.338 279.883 127.106C279.792 126.873 279.75 126.624 279.76 126.375C279.76 125.91 279.945 125.463 280.274 125.134C280.603 124.805 281.049 124.621 281.515 124.621C281.98 124.621 282.426 124.805 282.755 125.134C283.084 125.463 283.269 125.91 283.269 126.375L283.312 126.49ZM280.149 126.217H283.025C283.025 125.835 282.873 125.47 282.603 125.2C282.334 124.93 281.968 124.779 281.587 124.779C281.205 124.779 280.84 124.93 280.57 125.2C280.3 125.47 280.149 125.835 280.149 126.217Z"
        fill="#263238"
      />
      <path
        d="M288.058 126.404C288.072 126.648 288.035 126.893 287.95 127.122C287.864 127.351 287.732 127.56 287.562 127.736C287.392 127.912 287.187 128.05 286.96 128.143C286.734 128.235 286.49 128.28 286.246 128.273C285.951 128.271 285.662 128.189 285.409 128.038C285.157 127.886 284.949 127.669 284.808 127.41V129.611H284.463V124.563H284.793V125.44C284.927 125.172 285.132 124.946 285.386 124.787C285.639 124.627 285.932 124.54 286.231 124.535C286.477 124.528 286.721 124.573 286.948 124.665C287.175 124.757 287.381 124.896 287.552 125.071C287.724 125.246 287.857 125.455 287.944 125.685C288.031 125.914 288.07 126.159 288.058 126.404ZM287.713 126.404C287.69 126.125 287.587 125.86 287.416 125.639C287.245 125.418 287.014 125.252 286.75 125.16C286.486 125.069 286.201 125.056 285.93 125.124C285.659 125.192 285.414 125.337 285.224 125.542C285.034 125.747 284.908 126.003 284.862 126.278C284.815 126.553 284.849 126.836 284.961 127.093C285.072 127.349 285.256 127.567 285.489 127.72C285.722 127.874 285.995 127.956 286.275 127.957C286.474 127.958 286.67 127.917 286.853 127.838C287.035 127.758 287.199 127.642 287.334 127.496C287.469 127.35 287.573 127.178 287.638 126.99C287.703 126.802 287.728 126.602 287.713 126.404Z"
        fill="#263238"
      />
      <path
        d="M249.879 217.874H251.835C252.174 217.848 252.516 217.893 252.837 218.005C253.159 218.117 253.454 218.295 253.704 218.526C253.954 218.758 254.153 219.038 254.29 219.351C254.426 219.663 254.496 220 254.496 220.34C254.496 220.681 254.426 221.018 254.29 221.33C254.153 221.643 253.954 221.923 253.704 222.155C253.454 222.386 253.159 222.564 252.837 222.676C252.516 222.788 252.174 222.833 251.835 222.807H249.879V217.874ZM251.806 222.476C252.378 222.476 252.927 222.249 253.331 221.844C253.736 221.44 253.963 220.891 253.963 220.319C253.963 219.747 253.736 219.198 253.331 218.794C252.927 218.389 252.378 218.162 251.806 218.162H250.238V222.476H251.806Z"
        fill="#263238"
      />
      <path
        d="M258.694 221.052H255.53C255.53 221.251 255.57 221.448 255.65 221.631C255.729 221.813 255.845 221.977 255.991 222.112C256.137 222.247 256.31 222.351 256.498 222.416C256.686 222.481 256.885 222.506 257.083 222.49C257.313 222.52 257.548 222.494 257.765 222.414C257.983 222.334 258.178 222.202 258.334 222.03L258.536 222.26C258.36 222.467 258.139 222.629 257.889 222.734C257.639 222.839 257.368 222.883 257.098 222.864C256.847 222.878 256.596 222.84 256.362 222.752C256.127 222.663 255.913 222.526 255.734 222.35C255.555 222.174 255.415 221.963 255.323 221.729C255.231 221.496 255.189 221.246 255.2 220.995C255.2 220.53 255.384 220.083 255.713 219.754C256.042 219.425 256.489 219.24 256.954 219.24C257.419 219.24 257.865 219.425 258.194 219.754C258.523 220.083 258.708 220.53 258.708 220.995L258.694 221.052ZM255.53 220.779H258.406C258.388 220.41 258.228 220.063 257.96 219.808C257.693 219.554 257.338 219.413 256.968 219.413C256.599 219.413 256.244 219.554 255.976 219.808C255.708 220.063 255.549 220.41 255.53 220.779Z"
        fill="#263238"
      />
      <path
        d="M262.893 221.052H259.772C259.772 221.251 259.812 221.448 259.892 221.631C259.971 221.813 260.087 221.977 260.233 222.112C260.379 222.247 260.552 222.351 260.74 222.416C260.928 222.481 261.127 222.506 261.325 222.49C261.549 222.502 261.771 222.461 261.976 222.371C262.181 222.281 262.362 222.145 262.504 221.973L262.706 222.203C262.531 222.41 262.31 222.573 262.06 222.678C261.81 222.783 261.538 222.827 261.268 222.807C261.017 222.821 260.766 222.783 260.532 222.694C260.297 222.606 260.083 222.469 259.904 222.293C259.726 222.117 259.586 221.905 259.493 221.672C259.401 221.438 259.359 221.188 259.37 220.937C259.348 220.693 259.377 220.446 259.455 220.213C259.534 219.98 259.66 219.766 259.825 219.585C259.991 219.404 260.193 219.259 260.418 219.16C260.642 219.06 260.886 219.009 261.131 219.009C261.377 219.009 261.62 219.06 261.845 219.16C262.07 219.259 262.271 219.404 262.437 219.585C262.603 219.766 262.729 219.98 262.807 220.213C262.886 220.446 262.915 220.693 262.893 220.937C262.893 220.937 262.893 221.009 262.893 221.052ZM259.744 220.779H262.62C262.601 220.41 262.441 220.063 262.174 219.809C261.906 219.554 261.551 219.413 261.182 219.413C260.817 219.42 260.469 219.565 260.208 219.818C259.946 220.072 259.79 220.415 259.772 220.779H259.744Z"
        fill="#263238"
      />
      <path
        d="M267.652 220.966C267.666 221.21 267.63 221.455 267.544 221.684C267.459 221.913 267.327 222.123 267.157 222.298C266.986 222.474 266.781 222.612 266.555 222.705C266.328 222.797 266.085 222.842 265.841 222.835C265.543 222.836 265.252 222.755 264.998 222.6C264.744 222.445 264.538 222.223 264.403 221.958V224.173H264.043V219.154H264.388V220.017C264.53 219.741 264.747 219.51 265.014 219.352C265.281 219.195 265.588 219.116 265.898 219.125C266.135 219.127 266.37 219.177 266.587 219.271C266.805 219.365 267.002 219.502 267.165 219.674C267.329 219.845 267.457 220.048 267.54 220.27C267.624 220.492 267.662 220.729 267.652 220.966ZM267.293 220.966C267.271 220.688 267.168 220.422 266.997 220.201C266.826 219.98 266.594 219.814 266.33 219.722C266.066 219.631 265.781 219.618 265.51 219.686C265.239 219.754 264.994 219.899 264.804 220.104C264.615 220.309 264.489 220.565 264.442 220.84C264.395 221.116 264.429 221.399 264.541 221.655C264.652 221.911 264.836 222.129 265.069 222.282C265.303 222.436 265.576 222.518 265.855 222.519C266.054 222.52 266.251 222.479 266.433 222.4C266.616 222.32 266.78 222.204 266.915 222.058C267.05 221.912 267.153 221.74 267.218 221.552C267.283 221.364 267.309 221.164 267.293 220.966Z"
        fill="#263238"
      />
      <path
        d="M270.155 222.174L270.327 221.901C270.767 222.311 271.35 222.533 271.952 222.519C272.93 222.519 273.39 222.088 273.39 221.556C273.39 220.118 270.313 220.966 270.313 219.14C270.313 218.45 270.845 217.831 272.053 217.831C272.565 217.841 273.063 217.995 273.491 218.277L273.347 218.565C272.946 218.298 272.477 218.153 271.995 218.148C271.046 218.148 270.557 218.593 270.557 219.14C270.557 220.578 273.635 219.744 273.635 221.541C273.635 222.231 273.074 222.835 271.851 222.835C271.224 222.83 270.62 222.595 270.155 222.174Z"
        fill="#263238"
      />
      <path
        d="M274.828 217.572H275.188V222.807H274.828V217.572Z"
        fill="#263238"
      />
      <path
        d="M279.775 221.052H276.611C276.61 221.253 276.651 221.451 276.732 221.634C276.812 221.818 276.929 221.982 277.077 222.118C277.225 222.253 277.399 222.356 277.588 222.42C277.778 222.485 277.979 222.508 278.179 222.49C278.399 222.499 278.619 222.457 278.821 222.368C279.023 222.278 279.202 222.143 279.343 221.973L279.559 222.203C279.382 222.407 279.16 222.569 278.911 222.673C278.661 222.778 278.391 222.824 278.121 222.807C277.871 222.819 277.621 222.779 277.387 222.69C277.154 222.6 276.941 222.463 276.762 222.288C276.584 222.112 276.444 221.902 276.351 221.669C276.258 221.437 276.215 221.187 276.223 220.937C276.209 220.697 276.245 220.456 276.327 220.229C276.41 220.003 276.538 219.796 276.704 219.621C276.87 219.446 277.069 219.307 277.291 219.211C277.512 219.116 277.751 219.068 277.992 219.068C278.231 219.065 278.469 219.112 278.69 219.206C278.91 219.3 279.109 219.438 279.274 219.612C279.439 219.786 279.566 219.993 279.647 220.218C279.728 220.444 279.762 220.684 279.746 220.923C279.746 220.923 279.775 221.009 279.775 221.052ZM276.626 220.779H279.502C279.502 220.398 279.35 220.032 279.08 219.762C278.811 219.493 278.445 219.341 278.064 219.341C277.682 219.341 277.316 219.493 277.047 219.762C276.777 220.032 276.626 220.398 276.626 220.779Z"
        fill="#263238"
      />
      <path
        d="M283.988 221.052H280.824C280.824 221.251 280.865 221.448 280.944 221.631C281.023 221.813 281.14 221.977 281.285 222.112C281.431 222.247 281.604 222.351 281.792 222.416C281.98 222.481 282.179 222.506 282.378 222.49C282.601 222.502 282.824 222.461 283.028 222.371C283.233 222.281 283.414 222.145 283.557 221.973L283.758 222.203C283.581 222.407 283.359 222.568 283.11 222.673C282.86 222.778 282.59 222.824 282.32 222.807C282.071 222.819 281.821 222.779 281.588 222.69C281.355 222.6 281.143 222.463 280.966 222.287C280.789 222.111 280.65 221.9 280.559 221.668C280.468 221.436 280.426 221.187 280.436 220.937C280.436 220.472 280.621 220.026 280.95 219.697C281.279 219.368 281.725 219.183 282.191 219.183C282.656 219.183 283.102 219.368 283.431 219.697C283.76 220.026 283.945 220.472 283.945 220.937L283.988 221.052ZM280.824 220.779H283.7C283.7 220.398 283.549 220.032 283.279 219.762C283.01 219.493 282.644 219.341 282.262 219.341C281.881 219.341 281.515 219.493 281.246 219.762C280.976 220.032 280.824 220.398 280.824 220.779Z"
        fill="#263238"
      />
      <path
        d="M288.733 220.966C288.748 221.21 288.711 221.455 288.625 221.684C288.54 221.913 288.408 222.123 288.238 222.298C288.067 222.474 287.863 222.612 287.636 222.705C287.409 222.797 287.166 222.842 286.922 222.835C286.625 222.833 286.335 222.75 286.081 222.596C285.828 222.441 285.622 222.221 285.484 221.958V224.173H285.139V219.154H285.469V220.017C285.606 219.753 285.812 219.53 286.066 219.373C286.319 219.216 286.609 219.131 286.907 219.125C287.15 219.117 287.393 219.159 287.619 219.249C287.845 219.339 288.05 219.475 288.222 219.647C288.393 219.82 288.527 220.026 288.615 220.253C288.703 220.48 288.744 220.723 288.733 220.966ZM288.388 220.966C288.366 220.688 288.263 220.422 288.092 220.201C287.921 219.98 287.69 219.814 287.426 219.722C287.162 219.631 286.877 219.618 286.606 219.686C286.335 219.754 286.09 219.899 285.9 220.104C285.71 220.309 285.584 220.565 285.537 220.84C285.491 221.116 285.525 221.399 285.636 221.655C285.748 221.911 285.931 222.129 286.165 222.282C286.398 222.436 286.671 222.518 286.95 222.519C287.149 222.52 287.346 222.479 287.529 222.4C287.711 222.32 287.875 222.204 288.01 222.058C288.145 221.912 288.249 221.74 288.314 221.552C288.379 221.364 288.404 221.164 288.388 220.966Z"
        fill="#263238"
      />
      <path
        d="M568.466 422.875H22.0293V431.502H568.466V422.875Z"
        fill="#263238"
      />
    </svg>
  );
};
